<template>
  <div class="padding-xl padding-top">
    <div class="padding-bottom text-red ">
      <el-button @click="$router.back()" type="text" size="medium">
        <span class="text-lg"><i class="cuIcon-back"></i>返回列表</span>
      </el-button>
    </div>
    <div class="shadow-warp">
      <div class="padding solid-bottom text-red text-lg"><i class="cuIcon-titles"></i> 订单信息</div>
      <div class="padding">
        <div class="flex justify-start align-center">
          <div class="info-label">订单流水号：</div>
          <div>{{ order.no }}</div>
        </div>
        <div class="flex justify-start align-center padding-top">
          <div class="info-label">订单金额：</div>
          <div><span class="text-red">¥ {{ order.amount }}</span></div>
        </div>
        <div v-if="order.type === '集体订阅'" class="flex justify-start align-center padding-top">
          <div class="info-label">征订单位名称：</div>
          <div>{{ order.community }}</div>
        </div>
      </div>
      <div class="padding">
        <div class="flex justify-start align-center padding-bottom-sm">
          <div class="info-label ">订阅信息：</div>
          <div></div>
        </div>
        <el-table
          border
          :stripe="true"
          :data="page"
          :max-height="400"
          :header-cell-style="headerStyle"
          :cell-style="cellStyle"
          :row-style="{height: '40px',padding: '0'}"
          style="width: 100%">
          <el-table-column v-for="(item, index) in headers" :key="'f_' + index"
                           :prop="item.prop"
                           :label="item.label"
                           :width="item.width">
          </el-table-column>
          <el-table-column :label="item.label" v-for="(item, index) in headerGroups" :key="'j_' + index">
            <el-table-column v-for="(i, ind) in item.subs" :key="'k_' + ind"
                             :prop="i.prop"
                             :label="i.label"
                             :width="i.width">
            </el-table-column>
          </el-table-column>
        </el-table>
        <div class="padding-tb-xl">
          <el-pagination
            background
            :page-size="pageSize"
            @size-change="sizeChanged"
            @current-change="currentChanged"
            :current-page="currentPage"
            :page-sizes="[10, 20, 40, 80]"
            layout="total, sizes, prev, pager, next"
            :total="tableData.length">
          </el-pagination>
        </div>
      </div>
    </div>
    <div class="padding"></div>
    <div class="shadow-warp">
      <div class="padding solid-bottom text-red text-lg"><i class="cuIcon-titles"></i> 付款信息</div>
      <div class="padding">
        <div v-if="!order.pay.id" class="padding">暂无支付信息</div>
        <div v-else>
          <div class="flex align-center padding-top">
            <div class="flex justify-start align-center">
              <div class="info-label">支付类型：</div>
              <div class="view-label">{{ order.pay.payType }}</div>
            </div>
            <div class="flex justify-start align-center padding-left-xl">
              <div class="info-label">支付时间：</div>
              <div class="view-label">{{ order.pay.payTime }}</div>
            </div>
          </div>
          <div class="flex align-center padding-top">
            <div class="flex justify-start align-center">
              <div class="info-label">支付状态：</div>
              <div class="view-label">{{ payStatus[order.pay.payState] || '未支付' }}</div>
            </div>
            <div class="flex justify-start align-center padding-left-xl">
              <div class="info-label">支付金额：</div>
              <div class="view-label">¥ {{ order.amount }}</div>
            </div>
          </div>
          <div class="flex align-center padding-top" v-if="order.pay.payAccount">
            <div class="flex justify-start align-center">
              <div class="info-label">汇款帐号：</div>
              <div class="view-label">{{ order.pay.payAccount }}</div>
            </div>
          </div>
          <div class="flex align-center padding-top" v-if="order.pay.payOrg">
            <div class="flex justify-start align-center">
              <div class="info-label">汇款人名称：</div>
              <div class="view-label">{{ order.pay.payOrg }}</div>
            </div>
          </div>
          <div class="flex align-center padding-top" v-if="order.pay.payAccount">
            <div class="flex justify-start align-center">
              <div class="info-label">汇款说明：</div>
              <div class="view-label">{{ order.pay.payRemark }}</div>
            </div>
          </div>
          <div class="flex align-center padding-top" v-if="order.pay.payAccount">
            <div class="flex justify-start align-center">
              <div class="info-label">汇款凭证：</div>
              <div class="view-label">
                <img width="480" height="270" :src="imageBaseUrl + order.pay.payPic" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="padding"></div>
    <div class="shadow-warp">
      <div class="padding solid-bottom text-red text-lg"><i class="cuIcon-titles"></i> 开票信息</div>
      <div class="padding">
        <div v-if="!order.invoice.id" class="padding">暂无开票信息</div>
        <div v-else-if="order.invoiceType !== 2">
          <div class="flex align-center padding-top">
            <div class="flex justify-start align-center">
              <div class="info-label">开票类型：</div>
              <div class="view-label">{{ order.invoice.invoiceType }}</div>
            </div>
            <div class="flex justify-start align-center padding-left-xl">
              <div class="info-label">开票时间：</div>
              <div class="view-label">{{ order.invoice.createTime }}</div>
            </div>
          </div>
          <div class="flex align-center padding-top">
            <div class="flex justify-start align-center">
              <div class="info-label">开票状态：</div>
              <div class="view-label">{{ invoiceStatus[order.invoice.invoiceState] || '未开票' }}</div>
            </div>
            <div class="flex justify-start align-center padding-left-xl">
              <div class="info-label">开票金额：</div>
              <div class="view-label">¥ {{ order.amount }}</div>
            </div>
          </div>
          <div class="flex align-center padding-top">
            <div class="flex justify-start align-center">
              <div class="info-label">单位名称：</div>
              <div class="view-label">{{ order.invoice.invoiceOrg }}</div>
            </div>
            <div v-if="e_invoice" class="flex justify-start align-center padding-left-xl">
              <div class="info-label">接收邮箱：</div>
              <div class="view-label">{{ order.invoice.invoiceMail }}</div>
            </div>
            <div v-else class="flex justify-start align-center padding-left-xl">
              <div class="info-label">税号：</div>
              <div class="view-label">{{ order.invoice.invoiceTaxNum }}</div>
            </div>
          </div>
          <div v-if="!e_invoice" class="flex align-center padding-top">
            <div class="flex justify-start align-center">
              <div class="info-label">开户行：</div>
              <div class="view-label">{{ order.invoice.invoiceBank }}</div>
            </div>
            <div class="flex justify-start align-center padding-left-xl">
              <div class="info-label">帐号：</div>
              <div class="view-label">{{ order.invoice.invoiceBankAccount }}</div>
            </div>
          </div>
          <div v-if="e_invoice" class="flex align-center padding-top">
            <div class="flex justify-start align-center">
              <div class="info-label">接收电话：</div>
              <div class="view-label">{{ order.invoice.invoiceReceivePhone }}</div>
            </div>
            <div class="flex justify-start align-center padding-left-xl"
                 v-if="order.invoice.callback && order.invoice.callback.invoiceFile">
              <div class="info-label"></div>
              <div class="view-label">
                <el-link type="primary" @click="openDownload(order.invoice.callback.invoiceFile)">下载发票</el-link>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="flex justify-start align-center">
              <div class="info-label">电话：</div>
              <div class="view-label">{{ order.invoice.invoicePhone }}</div>
            </div>
            <div class="flex justify-start align-center">
              <div class="info-label">邮箱：</div>
              <div class="view-label">{{ order.invoice.invoiceMail }}</div>
            </div>
          </div>
          <div v-if="!e_invoice" class="flex align-center padding-top">
            <div class="flex justify-start align-center">
              <div class="info-label">地址：</div>
              <div class="view-label">{{ order.invoice.invoiceOrgAddress }}</div>
            </div>
          </div>
          <div class="flex align-center padding-tb">
            <div class="flex justify-start align-center">
              <div class="info-label">备注：</div>
              <div class="view-label">{{ order.invoice.invoiceRemark }}</div>
            </div>
          </div>
          <div v-if="!e_invoice">
            <el-divider content-position="left"><span class="text-red text-lg">发票邮寄信息</span></el-divider>
            <div class="flex align-center padding-top">
              <div class="flex justify-start align-center">
                <div class="info-label">收件单位：</div>
                <div class="view-label">{{ order.invoice.addressOrg }}</div>
              </div>
              <div class="flex justify-start align-center padding-left-xl">
                <div class="info-label">联系电话：</div>
                <div class="view-label">{{ order.invoice.addressPhone }}</div>
              </div>
            </div>
            <div class="flex align-center padding-top">
              <div class="flex justify-start align-center">
                <div class="info-label">收件人：</div>
                <div class="view-label">{{ order.invoice.addressPerson }}</div>
              </div>
              <div class="flex justify-start align-center padding-left-xl">
                <div class="info-label">邮编：</div>
                <div class="view-label">{{ order.invoice.addressZip }}</div>
              </div>
            </div>
            <div class="flex align-center padding-top">
              <div class="flex justify-start align-center">
                <div class="info-label">收货地址：</div>
                <div class="view-label">
                  <v-region type="text" v-model="addressSelected"></v-region>
                </div>
              </div>
            </div>
            <div class="flex align-center padding-top">
              <div class="flex justify-start align-center">
                <div class="info-label">街道：</div>
                <div class="view-label">{{ order.invoice.addressStreet }}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <el-table
            border
            :stripe="true"
            :data="splitList"
            :max-height="400"
            :header-cell-style="headerStyle"
            :cell-style="cellStyle"
            :row-style="{height: '40px',padding: '0'}"
            style="width: 100%">
            <el-table-column v-for="(item, index) in invoiceHeaders" :key="'i_' + index"
                             :prop="item.prop"
                             :label="item.label"
                             :width="item.width">
            </el-table-column>
            <el-table-column
              prop="invoiceFile"
              label="下载发票"
              width="87">
              <template v-slot="scope">
                <span v-if="!scope.row.requestNo">未开票</span>
                <span v-else-if="scope.row.invoiceFile">
                  <el-link :underline="false" type="primary" :href="scope.row.invoiceFile" target="_blank">下载发票</el-link>
                </span>
                <span v-else>{{scope.row.errorMessage}}</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="padding-tb-xl">
            <el-pagination
              background
              :page-size="splitPageSize"
              @size-change="splitSizeChanged"
              @current-change="splitCurrentChanged"
              :current-page="splitCurrentPage"
              :page-sizes="[10, 20, 40, 80]"
              layout="total, sizes, prev, pager, next"
              :total="splitList.length">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="padding-xl"></div>
    <el-dialog :show-close="false" :close-on-click-modal="false"
               title="下载发票"
               :visible.sync="downloadShow"
               width="30%">
      <span v-for="(item,index) in invoiceList" :key="index" class="padding-right-lg">
        <el-link :href="item" type="primary" target="_blank">发票{{ index + 1 }}</el-link>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="downloadShow = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import bs from '@/services/data/bs'
import config from '../../public/config/config'

export default {
  name: 'order-info',
  data () {
    return {
      downloadShow: false,
      invoiceList: [],
      currentPage: 1,
      pageSize: 10,
      page: [],
      order: {
        invoice: {}
      },
      addressSelected: {
        province: '',
        city: '',
        area: '',
        town: ''
      },
      e_invoice: true,
      invoiceStatus: {
        1: '已开票',
        2: '开票中',
        0: '开票失败'
      },
      payStatus: {
        0: '支付失败',
        1: '已支付',
        2: '审核中'
      },
      headers: [],
      headerGroups: [],
      tableData: [],
      splitList: [],
      splitPage: [],
      splitPageSize: 10,
      splitCurrentPage: 1,
      invoiceHeaders: [{
        prop: 'invoiceOrg',
        label: '发票抬头',
        width: 240
      }, {
        prop: 'invoiceTaxTin',
        label: '税号',
        width: 240
      }, {
        prop: 'invoicePhone',
        label: '手机号',
        width: 120
      }, {
        prop: 'invoiceEmail',
        label: '邮箱',
        width: 240
      }],
      imageBaseUrl: config.BASE_URL + '/static'
    }
  },
  created () {
    this.order = JSON.parse(sessionStorage.getItem('order'))
    if (this.order.invoiceType === 2) {
      bs.order.getInvoiceSplitList(this.order.id, (resp) => {
        if (resp.code === 200) {
          this.splitList = resp.data

          const orderNo = this.order.no
          const rowNoMap = {}
          for (let i = 0; i < this.order.list.length; i++) {
            const rowNo = this.order.list[i].rowNo
            if (!rowNoMap[orderNo + '' + rowNo]) {
              rowNoMap[orderNo + '' + rowNo] = this.order.list[i]
            }
          }

          for (let i = 0; i < this.splitList.length; i++) {
            const split = this.splitList[i]
            if (split.requestNo) {
              const detail = rowNoMap[split.saleSerialNo]
              if (detail) {
                split.invoiceOrg = detail.invoiceOrg
                split.invoiceTaxTin = detail.invoiceTaxTin
                split.invoicePhone = detail.invoicePhone
                split.invoiceEmail = detail.invoiceEmail
              }
            }
          }
          this.splitPage = this.splitList.slice(0, this.splitPageSize)
        }
      })
    }

    const products = []
    const prodMap = {}
    for (let i = 0; i < this.order.list.length; i++) {
      if (!prodMap[this.order.list[i].product]) {
        prodMap[this.order.list[i].product] = { bookFullname: this.order.list[i].product }
        products.push(prodMap[this.order.list[i].product])
      }
    }

    const rowMap = {}
    for (let i = 0; i < this.order.list.length; i++) {
      const detail = this.order.list[i]
      let row = this.createTableRow(detail)

      const key = JSON.stringify(row)
      if (!rowMap[key]) {
        rowMap[key] = row
        this.tableData.push(row)
      } else {
        row = rowMap[key]
      }

      let k = 0
      let found = false
      for (; k < products.length; k++) {
        if (products[k].bookFullname === detail.product) {
          found = true
          break
        }
      }
      if (found) {
        row[5 + k * 3] = detail.issueStart
        row[5 + k * 3 + 1] = detail.issueEnd
        row[5 + k * 3 + 2] = detail.qty
        row[(5 + k * 3) + '_amount'] = detail.amount
      }
    }
    this.page = this.tableData.slice(0, this.pageSize)
    this.createHeaders(products)
    if (!this.order.pay) {
      this.order.pay = {}
    }
    if (!this.order.invoice) {
      this.order.invoice = {}
    } else {
      const areas = this.order.invoice.addressArea.split(',', -1)
      this.addressSelected.province = areas[0]
      this.addressSelected.city = areas[1]
      this.addressSelected.area = areas[2]
      this.e_invoice = this.order.invoice.invoiceType !== '专票'
    }
  },
  methods: {
    openDownload (files) {
      this.invoiceList = files.split('#&#')
      this.downloadShow = true
    },
    createTableRow (detail) {
      return {
        0: detail.addressZip,
        1: detail.addressStreet,
        2: detail.addressOrg,
        3: detail.addressPerson,
        4: detail.addressPhone,
        valid: true
      }
    },
    splitCurrentChanged (pageNumber) {
      this.splitCurrentPage = pageNumber
      this.splitPage = this.splitList.slice((pageNumber - 1) * this.splitPageSize, pageNumber * this.splitPageSize)
    },
    splitSizeChanged (size) {
      this.splitCurrentPage = 1
      this.splitPageSize = size
      this.splitPage = this.splitList.slice(0, this.splitPageSize)
    },
    currentChanged (pageNumber) {
      this.currentPage = pageNumber
      this.page = this.tableData.slice((pageNumber - 1) * this.pageSize, pageNumber * this.pageSize)
    },
    sizeChanged (size) {
      this.currentPage = 1
      this.pageSize = size
      this.page = this.tableData.slice(0, this.pageSize)
    },
    nextStep () {
      this.$router.push({ path: '/pages/subscribe/pay' })
    },
    headerStyle () {
      return 'text-align:center;color:#666666;font-size:14px;padding:6px 0'
    },
    cellStyle (obj) {
      let rtn = 'padding:0;'
      if (obj.columnIndex !== 2 && obj.columnIndex !== 1) {
        rtn = rtn + 'text-align:center'
      }
      return rtn
    },
    createHeaders (products) {
      this.headers.push({
        prop: 0 + '',
        label: '邮编',
        width: 90
      })
      this.headers.push({
        prop: 1 + '',
        label: '地址',
        width: 320
      })
      this.headers.push({
        prop: 2 + '',
        label: '单位',
        width: 200
      })
      this.headers.push({
        prop: 3 + '',
        label: '收件人',
        width: 90
      })
      this.headers.push({
        prop: 4 + '',
        label: '手机号',
        width: 120
      })
      for (let i = 0, index = 5; i < products.length; i = i + 1, index = index + 3) {
        const group = {
          label: products[i].bookFullname,
          subs: []
        }
        group.subs.push({
          prop: index + '',
          label: '征订起始期数',
          width: 130
        })
        group.subs.push({
          prop: (index + 1) + '',
          label: '征订结束期数',
          width: 130
        })
        group.subs.push({
          prop: (index + 2) + '',
          label: '份数',
          width: 70
        })
        group.subs.push({
          prop: index + '_amount',
          label: '金额',
          width: 90
        })
        this.headerGroups.push(group)
      }
    }
  }
}
</script>

<style scoped>
.info-label {
  width: 100px;
  padding: 2px 0;
  text-align: right;
}

.view-label {
  min-width: 200px;
}
</style>
